import {useNavigate, useSearchParams} from "react-router-dom";
import {abacPolicySelector, useGetABACPolicyQuery} from "@ots-frontend/ots-data";
import {skipToken} from "@reduxjs/toolkit/query";
import {useMemo} from "react";
import {useTranslation} from "react-i18next";
import {ErrorPage} from "../../components/page/ErrorPage/ErrorPage";
import {ABACPolicyProfile} from "../../components/profile/ABACPolicyProfile/ABACPolicyProfile";
import {EntityProfilePage} from "../EntityProfilePage/EntityProfilePage";

type Props = {
  id?: string;
}

export const ABACPolicyProfilePageRoute = () => {
  const [params, _setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const {t} = useTranslation()

  const id = params.get("id") ?? undefined;

  if (!id) {
    navigate(-1);
    return (
      <ErrorPage
        message={t("common.entity.abacpolicy", "ABAC Policy") + " " + t("common.error.notfound", "Not Found")}/>
    );
  }

  return <ABACPolicyProfilePage id={id}/>;
};

export const ABACPolicyProfilePage = (props: Props) => {
  const {id} = props;

  const selectABACPolicy = useMemo(() => {
    return abacPolicySelector()
  }, []);

  const {abacPolicy, isFetching} = useGetABACPolicyQuery(id ?? skipToken, {
    selectFromResult: (result) => ({
      abacPolicy: selectABACPolicy(result),
      isFetching: result.isFetching
    })
  });

  return (
    <EntityProfilePage permissions={["abacpolicy_view"]} entity={abacPolicy} isLoading={isFetching}>
      {(entity) => (
        <ABACPolicyProfile abacPolicy={entity}/>
      )}
    </EntityProfilePage>
  )
};
